import React from "react";

export const SuccessIconLarge = () => {
  return (
    <>
      <svg
        width="102"
        height="102"
        viewBox="0 0 102 102"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_581_29766)">
          <circle
            cx="51"
            cy="47"
            r="45"
            fill="#23A26D"
            style={{
              fill: "#23A26D",
              fill: "color(display-p3 0.1373 0.6353 0.4275)",
              fillOpacity: 1,
            }}
          />
        </g>
        <path
          d="M36.2734 48.9627L49.5304 59.62L67.5221 34.2305"
          stroke="white"
          style={{ stroke: "white", strokeOpacity: 1 }}
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <defs>
          <filter
            id="filter0_d_581_29766"
            x="0.3"
            y="0.3"
            width="101.4"
            height="101.4"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2.85" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_581_29766"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_581_29766"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
